











































import Vue from 'vue'
import Component from 'vue-class-component'
import { Emit, Prop, Watch } from 'vue-property-decorator'
import VueMultiselect from 'vue-multiselect'
import { localisedSdgList, SDG } from '../utils/sdgs'
import { CategoryEntry } from '@/shared/models/category-entry'
import { TranslateService } from '@/shared/services/translate-service'
import { Injector } from '@/config/dependency-injection'
import { FormGroup } from '@/shared/forms/form-group'
import MultiselectClear from '@/shared/components/multiselect-clear.vue'

@Component({
  components: { MultiselectClear, VueMultiselect },
  data() {
    return {
      categories: undefined,
    }
  },
  inject: {
    form: {
      default: undefined,
    },
  },
})
export default class RespondecoCategories extends Vue {
  private translateService = Injector.get(TranslateService)

  @Prop({
    type: String,
  })
  private readonly control?: string

  @Prop({
    type: Boolean,
  })
  private readonly editMode!: boolean

  @Prop({
    default: '',
    type: String,
  })
  private readonly openDirection!: string

  // noinspection JSMismatchedCollectionQueryUpdate
  @Prop({
    type: Array,
  })
  private readonly value!: string[]

  @Prop({
    default: 50,
    type: Number,
  })
  private readonly width!: number

  // noinspection JSMismatchedCollectionQueryUpdate -- doesn't see the usage inside the template
  private categories!: CategoryEntry[]

  private form?: FormGroup<any>

  get availableCategories(): CategoryEntry[] {
    return localisedSdgList().map((sdg: SDG) => ({
      key: sdg,
      label: this.$t(`sdg.titles.${sdg}`) as string,
    }))
  }

  public mounted() {
    this.onInputChanged(this.value)

    if (this.form !== undefined && this.control !== undefined) {
      const field = this.form.field(this.control)

      this.$watch(
        () => field.$model,
        (newValue?: string[]) => {
          if (newValue !== undefined) {
            this.onInputChanged(newValue)
          }
        },
        {
          immediate: true,
        }
      )
    }
  }

  @Emit('input')
  public onValueChanged(values: CategoryEntry[]) {
    if (this.form !== undefined && this.control !== undefined) {
      this.form.field(this.control).$model = values.map(value => value.key)
    }

    return values.map(value => value.key)
  }

  @Watch('value')
  private onInputChanged(values: string[] = []) {
    this.categories = values.map(value => ({
      label: this.translateService.translate(`sdg.titles.${value}`),
      key: value,
    }))
  }
}
